import request from '@/utils/request'
//登录接口
export function login(code, state) {
  return request({
    url: '/get-openid/',
    method: 'post',
    data: {
      code,
      state
    }
  })
}
//发送验证码
export function sendSms(data) {
  return request({
    url: '/send-sms/',
    method: 'post',
    data
  })
}
//绑定手机 url
export function bindMobile(data) {
  return request({
    url: '/bind-mobile/',
    method: 'post',
    data
  })
}
//获取会员
export function getMember() {
  return request({
    url: '/member/',
    method: 'get'
  })
}
//根据uuid获取消费记录
export function getDataById(uuid, page) {
  return request({
    url: '/member/' + uuid + '/records/' + '?page=' + page,
    method: 'get',
  })
}

//获取微信授权登录redirect_url
export function getRedirectUrl() {
  return request({
    url: '/redirect-url/',
    method: 'get',
  })
}
//充值记录详情
export function getReCharge(code) {
  return request({
    url: '/deposit/'+ code + '/',
    method: 'get',
  })
}
//消费记录详情
export function getExpenseCalendar(code) {
  return request({
    url: '/order/'+ code + '/',
    method: 'get',
  })
}


export function checkBindRequest() {
  return request({
    url: '/check-bind/',
    method: 'get',
  })
}

export function removeBindRequest() {
  return request({
    url: '/remove-bind/',
    method: 'post',
  })
}

export function jssdkCardConfig(url) {
  return request({
    url: '/jssdk-card-config/',
    method: 'post',
    data: {
      url: url
    }
  })
}
export function jssdkConfig(url) {
  return request({
    url: '/jssdk-config/',
    method: 'post',
    data: {
      url: url
    }
  })
}
export function decrpytCard(encrypt_code) {
  return request({
    url: '/decrypt-card/',
    method: 'post',
    data: {
      encrypt_code: encrypt_code
    }
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js